"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateFnsFormat = require("date-fns/format");
var deLocale = require("date-fns/locale/de");
var startOfWeek = require("date-fns/start_of_week");
var addDays = require("date-fns/add_days");
var nodash_1 = require("./nodash");
function format(date, formatString, locale) {
    if (formatString === void 0) { formatString = 'DD.MM.YYYY'; }
    if (locale === void 0) { locale = 'de-de'; }
    if (locale !== 'de-de') {
        throw new Error('only german dates are supported at the moment');
    }
    if (date) {
        return dateFnsFormat(date, formatString, { locale: deLocale });
    }
    else {
        return '';
    }
}
exports.format = format;
function buildWeekdayLabelsForLocale(locale) {
    var monday = startOfWeek(new Date(2018, 0, 1), { weekStartsOn: 1 });
    return {
        long: nodash_1.range(0, 7).map(function (num) { return format(addDays(monday, num), 'dddd', locale); }),
        short: nodash_1.range(0, 7).map(function (num) { return format(addDays(monday, num), 'dd', locale); })
    };
}
exports.weekdayLabels = {
    'de-de': buildWeekdayLabelsForLocale('de-de')
};
function buildMonthLabelsForLocale(locale) {
    return nodash_1.range(0, 12).map(function (num) {
        return format(new Date(2018, num, 1), 'MMMM', locale);
    });
}
exports.monthLabels = {
    'de-de': buildMonthLabelsForLocale('de-de')
};
//# sourceMappingURL=dateFormat.js.map
